import { useEffect, useState } from 'react';
import { compose } from 'recompose';

import { AppBar, Box, CircularProgress, Toolbar, Typography } from '@mui/material';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import logo from '../../assets/logo.svg';
import { withFirebase } from '../Firebase';
import { PageLayout } from '../layout';
import MultiTenantForm from './CheckinForm/multiTenantForm';
import VisitorForm from './CheckinForm/visitorForm';
import { loadImageFromStorage } from './Settings/functions';

const VisitorScanIn = (props) => {
   let url = queryString.parse(window.location.search);
   const [location, setLocation] = useState(false);
   const [lids, setLids] = useState(false);
   const [llid, setLlid] = useState(false);
   const [landlocation, setLandlocation] = useState(false);
   const [customisations, setCustomisations] = useState(null);
   const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
   const [contractor, setContractor] = useState(false);
   const [kioskDisabled, setKioskDisabled] = useState(false);

   useEffect(() => {
      const fetchPageData = async () => {
         const locToCheck = url.loc || url.llid;
         if (locToCheck) {
            try {
               const visDoc = await props.firebase.db
                  .doc(`visitors/${locToCheck}`)
                  .get();
               if (!visDoc.exists || !visDoc.data().visitorsEnabled) {
                  setKioskDisabled(true);
                  return;
               }
            } catch (e) {
               console.warn(e);
               setKioskDisabled(true);
               return;
            }
         }
         try {
            if (url.llid) {
               if (url.contractor && url.contractor === 'true') {
                  setContractor(true);
               }
               setLlid(url.llid);
               setLandlocation(url.llocation);
               const landlord = await props.firebase.db
                  .doc(`visitors/${url.llid}`)
                  .get();
               if (landlord.exists) {
                  let tenantArray = [];
                  if (landlord.data().logoPath) {
                     tenantArray.push({
                        lid: url.llid,
                        logoPath: landlord.data().logoPath,
                        displayName: url.llocation,
                     });
                  }
                  if (landlord.data().tenantDetails) {
                     const tenants = landlord.data().tenantDetails;
                     const tenantEntries = Object.entries(tenants);
                     const tenantDocs = await Promise.all(
                        tenantEntries.map(([key]) =>
                           props.firebase.db.doc(`visitors/${key}`).get(),
                        ),
                     );
                     tenantEntries.forEach(([key, value], i) => {
                        if (
                           tenantDocs[i].exists &&
                           tenantDocs[i].data().visitorsEnabled
                        ) {
                           tenantArray.push({
                              lid: key,
                              ...value,
                           });
                        }
                     });
                     tenantArray.sort((a, b) =>
                        b.displayName.localeCompare(a.displayName),
                     );
                  }
                  if (
                     landlord.data().customisations?.welcomeBackgroundImagePath &&
                     landlord.data().customisations?.welcomeBackgroundImagePath !== null
                  ) {
                     try {
                        const url = await loadImageFromStorage(
                           landlord.data().customisations?.welcomeBackgroundImagePath,
                        );
                        setBackgroundImageUrl(url);
                     } catch (imgErr) {
                        console.warn(imgErr);
                        setBackgroundImageUrl(null);
                     }
                  } else {
                     setBackgroundImageUrl(null);
                  }
                  if (landlord.data().customisations) {
                     setCustomisations(landlord.data().customisations);
                  }
                  setLids(tenantArray);
               }
            } else if (url.loc) {
               const locDoc = await props.firebase.db.doc(`visitors/${url.loc}`).get();
               if (locDoc.exists && locDoc.data().customisations) {
                  setCustomisations(locDoc.data().customisations);
               }
            }
         } catch (e) {
            console.warn(e);
            setKioskDisabled(true);
            return;
         }
         if (url.locName && url.loc) {
            setLocation(url);
         }
      };
      fetchPageData();
      return () => {};
   }, []);

   return (
      <>
         <Box
            sx={{
               position: 'relative',
               width: '100%',
               height: '100vh',
               overflow: 'hidden',
            }}
         >
            {!location && lids && backgroundImageUrl !== null && (
               <Box
                  sx={{
                     position: 'absolute',
                     top: 0,
                     left: 0,
                     width: '100%',
                     height: '100%',
                     backgroundImage: `url(${backgroundImageUrl})`,
                     backgroundSize: 'cover',
                     backgroundPosition: 'center',
                     filter: 'grayscale(100%)',
                     opacity: 0.15,
                     zIndex: -1,
                  }}
               />
            )}
            <AppBar
               position="fixed"
               sx={{
                  backgroundImage: 'linear-gradient(16deg, #32bfc7, #349fb8)',
                  // zIndex: theme.zIndex.drawer + 1,
               }}
            >
               <Toolbar>
                  <Box sx={{ flexGrow: 1 }}>
                     <img src={logo} alt="InTheOffice Logo" style={{ height: '45px' }} />
                  </Box>
               </Toolbar>
            </AppBar>
            <PageLayout style={{ backgroundColor: '#f2f2f2' }}>
               {kioskDisabled ? (
                  <Box
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     height="100vh"
                     flexDirection="column"
                     sx={{ p: 4, textAlign: 'center' }}
                  >
                     <Typography variant="h4" component="h1" gutterBottom>
                        Visitor check-in is unavailable
                     </Typography>
                     <Typography variant="body1">
                        Visitor Management is not enabled for this location. Please speak
                        to your intheOffice administrator.
                     </Typography>
                  </Box>
               ) : !location && lids ? (
                  <MultiTenantForm
                     setLocation={setLocation}
                     lids={lids}
                     llid={llid}
                     landlocation={landlocation}
                     customisations={customisations}
                  />
               ) : location ? (
                  <VisitorForm
                     location={location}
                     lids={lids}
                     llid={llid}
                     landlocation={landlocation}
                     customisations={customisations}
                     contractor={contractor}
                  />
               ) : (
                  <Box
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     height="100vh"
                     flexDirection="column"
                  >
                     <CircularProgress />
                  </Box>
               )}
            </PageLayout>
         </Box>
      </>
   );
};

const VisitorScanInForm = compose(withRouter, withFirebase)(VisitorScanIn);

export default withFirebase(VisitorScanInForm);
